import { systemCode } from '@root/package.json';

/** 当前系统编码 */
export const CURRENT_CLIENT_CODE = systemCode;

// eslint-disable-next-line vue/max-len
export const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCuC0rzvevXPMABNibaXR1l5/hPJyz4mhDP/LtB4q/n9taCNzXrqLQyp5dI+2KON/KF6B07rQcRNiNvDOCqdkV+cLa4PKgRtRY7sN4C6j4NXFKvU0RDrIfNhg9KGAvfK8CY7qqneAhfrWw02DTh1m/AQd+8GkzDG5sHuzIDLZjj0QIDAQAB';
